import React from "react";

function TextError(props) {
  return <div className="invalid-feedback">{props.children}</div>;
}

export default TextError;
